import { render, staticRenderFns } from "./AppCompaniesComponent.vue?vue&type=template&id=8c0bf960&scoped=true&"
import script from "./AppCompaniesComponent.vue?vue&type=script&lang=js&"
export * from "./AppCompaniesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0bf960",
  null
  
)

export default component.exports